export default {
    'shareCoupon.title': 'Gift Coupon Transfer',
    'shareCoupon.success': 'Transfer Successful',
    'shareCoupon.alt_text': 'Your gift is here! Check it out now～',
    'shareCoupon.unit': 'Piece',
    'shareCoupon.button': 'Open My Gift',
    'shareCoupon.notice_message': 'Wait for your friend to claim it within 24 hours. After claiming, it will be considered a successful transfer. If not claimed, it will be returned to you.',
    'shareCoupon.share_fail_message': 'Transfer failed, your Line version is outdated, please update Line.',
    'shareCoupon.wrong_quantity': 'Incorrect transfer quantity',
    'shareCoupon.wrong_product': 'This product cannot be transferred',
    'shareCoupon.fail': 'Transfer failed',
    'shareCoupon.please_enter_quantity': 'Please enter the transfer quantity',
    'shareCoupon.you_have': 'You currently have',
    'shareCoupon.next_step': 'Next Step',
} as Record<string, string>;
